<form class="popupForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      User referrals
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke flex-justify-start" style="display: flex !important; height: 500px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        >.< error. <br>{{errMsg}}
      </div>
      <ng-container *ngIf="state==='default'">
        <div *ngIf="referrals && referrals.length"
             style="margin: 20px 0px; font-size: 0.8em;">
          {{profile.shipping_name}} has {{referrals.length}} referrals.
        </div>
        <div  *ngIf="!referrals || !referrals.length"
              style="margin: 20px 0px; font-size: 0.8em;">
          {{profile.shipping_name}} has no referrals.
        </div>

        <div *ngIf="!referrals || !referrals.length" class="flex-row-center flex-justify-center" style="height: 80%">
          <button mat-raised-button class="toolbar-top-btn new-folder-btn" color="accent"
                  [disabled]="pickItemsLoading" (click)="pickReferral()">
            <mat-icon>add</mat-icon>
            <div style="display: inline; margin-left: 10px">{{'add_new_referral'|GetLabelPipe}}</div>
          </button>
        </div>
        <div *ngIf="referrals && referrals.length" class="events-listing-container listing-full-size" style="margin-top: 20px !important;">

          <cdk-virtual-scroll-viewport itemSize="typicalItemHeight" minBufferPx="300" maxBufferPx="600"
                                       class="cdk-scroll">
            <div  class="file-row noselect" [class.center75]="true"
                  *cdkVirtualFor="let listItem of referrals; let idx = index">
              <div matBadge="{{listItem.itemFullData['rank']}}" matBadgeColor="accent">
                <img alt="" title="{{listItem.name}}"
                     src="{{listItem.picture_ava}}" class="list-item-image"
                     style="{{ listItem.itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
                />
              </div>

              <div class="file-name noselect" style="width: 70%;">
                {{listItem.name}}<br/>
                <div class="subrow subrow-trainer flex-row-center" *ngIf="listItem['itemFullData']['shipping_phone']">
                  <mat-icon style="width: 16px;">phone</mat-icon>&nbsp;&nbsp;&nbsp;+{{listItem['itemFullData']['shipping_phone']}}
                </div>
              </div>

              <div class="file-menu" style="text-align: center">
                <button type="submit" mat-raised-button color="accent"
                        [disabled]="state === 'loading'" [disabled]="pickItemsLoading" (click)="deleteReferral(listItem)">
                  {{'delete'|GetLabelPipe}}
                </button>
              </div>
            </div>
          </cdk-virtual-scroll-viewport>

        </div>
        <br>
      </ng-container>

    </mat-dialog-content>
    <div *ngIf="referrals && referrals.length" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        {{'cancel'|GetLabelPipe}}
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent"
              [disabled]="state === 'loading'" [disabled]="pickItemsLoading" (click)="pickReferral()">
        {{'add_new_referral'|GetLabelPipe}}
      </button>
    </div>
  </div>
</form>
